<template>
  <div class="shareholder">
    <h3 style="margin-bottom:20px;">信用主管信息</h3>
    <TableView :data="data" :columns="columns" :pagination="false">
      <template v-slot:action="{ tableRow }">
        <div>
          <a-button type="link" size="small" @click="handleEdit(tableRow)">
            编辑
          </a-button>
          <a-divider type="vertical" />
          <a-popconfirm
            title="是否删除该文档类型?"
            @confirm="handleDeleteConfirm(tableRow)"
          >
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a-button type="link" size="small">
              删除
            </a-button>
          </a-popconfirm>
        </div>
      </template>
    </TableView>

    <div>
      <a-button class="width-100" icon="plus" type="dashed" @click="add">
        新增联系人
      </a-button>
    </div>
    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
    >
      <a-form :form="modalForm">
        <a-form-item label="ITcode">
          <a-select
            allowClear
            showSearch
            @blur="value => handleNameChange(value)"
            option-filter-prop="children"
            v-decorator="$decorator('username', '请选择ITcode')"
          >
            <a-select-option
              v-for="item in userList"
              :value="item.username"
              :key="item.username"
            >
              {{ item.username }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="姓名">
          <a-input :disabled="disabled" v-decorator="['name']"></a-input>
        </a-form-item>
        <a-form-item label="业务类型">
          <a-select
            showSearch
            option-filter-prop="children"
            v-decorator="['businessId']"
            @change="value => handleBusinessChange(value)"
            @focus="handleFocus"
          >
            <a-select-option
              v-for="item in businessList"
              :value="item.id"
              :key="item.id"
              :disabled="item.disabled"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="业务模式">
          <a-select
            v-decorator="['modelId']"
            showSearch
            option-filter-prop="children"
            @focus="handleModelFocus"
          >
            <a-select-option
              v-for="item in modelOptionList"
              :value="item.id"
              :key="item.id"
              :disabled="item.disabled"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { TableView } from 'lxfintech-fe'
import { mapGetters } from 'vuex'
import mixin from './mixinContact'
import {
  getCreditmanager,
  addShareholders,
  getListCManager,
  getBusinessList,
  getRegionList,
  remove,
  getFreezeBgList,
  getFreezeModelList,
} from '../api'
const data = [],
  SET_MODEL = 3

export default {
  mixins: [mixin],
  name: 'create-info',
  props: ['permissions', 'customerDetail'],
  data() {
    return {
      modalForm: this.$form.createForm(this),
      data,
      modalTitle: '新增',
      visible: false,
      disabled: false,
      userList: [],
      nameValue: '',
      businessList: [],
      Model_Name: '',
      modelOptionList: [],
      syList: [], //BG冻结
      modelList: [], //业务模式冻结
    }
  },
  computed: {
    ...mapGetters('app', ['company']),
  },
  components: {
    TableView,
  },
  mounted() {
    this._getListCManager()
    this._getBusinessList()
    this.query()
    this._getFreezeBgList()
  },
  methods: {
    handleFocus() {
      if (this.businessList) {
        this.businessList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.syList) {
        this.businessList.forEach(item => {
          this.syList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //一定要刷新组件！！！！！！！！！！！！
      }
    },

    //业务模式禁用
    handleModelFocus() {
      if (this.modelOptionList) {
        this.modelOptionList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.modelList) {
        this.modelOptionList.forEach(item => {
          this.modelList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //刷新组件
      }
    },

    //遍辑时赋值联动
    async editChangeName(value) {
      this._getListCManager()
      return this.userList.filter(item => {
        if (item.username === value) {
          return item.name
        }
      })
    },
    // 联动username与Name
    async handleNameChange(value) {
      this._getListCManager()
      this.userList.filter(item => {
        if (item.username === value) {
          return this.modalForm.setFieldsValue({ name: item.name })
        }
      })
    },
    async query() {
      const { data } = await getCreditmanager(this.company.code)
      this.data = data
    },
    handleModelChange(value) {
      ;[SET_MODEL].forEach(type => {
        this.fetchRegionList(value, type)
      })
    },
    //大区｜模式 联动
    handleBusinessChange(value) {
      ;[SET_MODEL].forEach(type => {
        this.fetchRegionList(value, type)
      })
      this.modalForm.setFieldsValue({ modelId: '' })
    },
    async fetchRegionList(pid, type) {
      try {
        const { data } = await getRegionList({ pid, type })
        this.setOptionListByType(type, data)
      } catch (error) {
        console.error(error)
      }
    },
    setOptionListByType(type, data) {
      switch (type) {
        case SET_MODEL:
          this.modelOptionList = data
          this._getFreezeModelList()
          data.unshift({
            id: '000',
            name: 'All',
            username: 'All',
          })
          return
      }
    },
    _getFreezeModelList() {
      getFreezeModelList().then(({ data }) => {
        this.modelList = data
      })
    },
    //业务类型
    async _getBusinessList() {
      const { data } = await getBusinessList()
      data.unshift({
        id: '000',
        name: 'All',
        username: 'All',
      })
      this.businessList = data
    },
    _getFreezeBgList() {
      getFreezeBgList().then(({ data }) => {
        this.syList = data
      })
    },
    // 信用主管 ｜ 商务主管 -fetch get optionList
    _getListCManager() {
      getListCManager().then(({ data }) => {
        this.userList = data
      })
    },
    // 取消弹框
    handleAfterClose() {
      this.modelOptionList = []
      this.id = null
      this.modalTitle = '新增'
    },
    // 提交
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (!this.id) {
            this.id = null
          }
          try {
            const { message } = await addShareholders({
              ...values,
              id: this.id,
              companyCode: this.customerDetail.base.code,
            })
            this.visible = false
            this.$notification.success({
              message: '提示',
              description: message,
            })
            this.query()
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    async handleDeleteConfirm({ id }) {
      try {
        await remove(id)
        this.$notification.success({
          message: '提示',
        })
        this.query()
      } catch (error) {
        console.log(error)
      }
    },
    async handleEdit({ username, name, businessId, modelId, id }) {
      this.visible = true
      this.modalForm.getFieldDecorator('name', {
        initialValue: name,
        preserve: false,
      })
      this.handleModelChange(businessId)
      this.modalTitle = '编辑'
      this.modalTitle === '编辑'
        ? (this.disabled = true)
        : (this.disabled = false)
      setTimeout(() => {
        this.$nextTick(() => {
          this.modalForm.setFieldsValue({
            username,
            name,
            businessId,
            modelId,
          })
        })
        this.id = id
      }, 20)
    },
    add() {
      this.disabled = true
      this.visible = true
      this.modalForm.resetFields()
      this.modelOptionList = []
    },
  },
}
</script>
<style lang="less" scoped>
.shareholder {
  /deep/ .margin-left-20 {
    margin-left: 20px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  /deep/ .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  /deep/.margin-bottom-20 {
    margin-bottom: 20px;
  }
  /deep/ .editable-row-operations a {
    margin-right: 8px;
  }
  /deep/ .shareholder-add-btn {
    margin-top: 20px;
    .editable-add-btn {
      width: 100%;
    }
  }
}
/deep/ .editable-row-operations a {
  margin-right: 8px;
}
/deep/ .margin-top-20 {
  margin-top: 20px;
}
/deep/ .width-100 {
  width: 100%;
}
</style>
